import { Table as TanStackTable } from "@tanstack/react-table";
import { downloadCsv } from "../downloadCsv";

const downloadTableAsCsv = <T>(options: { filename: string; table: TanStackTable<T> | null }) => {
  if (options.table == null) {
    return;
  }

  const visibleColumns = options.table.getVisibleLeafColumns();

  const headers = visibleColumns.map((column) => {
    return typeof column.columnDef.header === "string" ? `"${column.columnDef.header}"` : `"${column.id}"`;
  });

  const rows = options.table.getPrePaginationRowModel().rows.map((row) => {
    return visibleColumns
      .map((column) => {
        return `"${row.getValue(column.id) ?? ""}"`;
      })
      .join(",");
  });

  const csvData: string[] = [];

  csvData.push(headers.join(","));
  csvData.push(rows.join("\n"));

  downloadCsv({
    filename: options.filename,
    csv: csvData.join("\n"),
  });
};

export { downloadTableAsCsv };
